// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
import { enabledWhen, visibleWhen } from './common'

const ColorSelect = (props: IElementProps) => {
  const { t } = useTranslation('common')
  const [savedExternalData, setSavedExternalData] = useState<IExternalDataItem>(null)
  const [showCantons, setShowCantons] = useState([])
  const [showAllCantons, setShowAllCantons] = useState(false)
  useEffect(() => {
    const { externalData } = props
    if ((externalData?.timeStamp || 0) > (savedExternalData?.timeStamp || 0)) {
      setSavedExternalData(externalData)
    }
  }, [props.externalData])

  const optionsToRender = !!savedExternalData
    ? Object.keys(savedExternalData.data).map((key) => ({
        name: key,
        value: savedExternalData.data[key],
        enabledWhen: true,
      }))
    : props.options
        .filter((o) => visibleWhen(o.visibleWhen, props.data))
        .map((o) => ({
          name: o.name,
          value: o.value,
          enabledWhen: enabledWhen(o.enabledWhen, props.data),
        }))

  const cantonsRef = useRef(null)

  function handleDocumentClick(e: Event) {
    if (cantonsRef.current.contains(e.target)) {
      return
    } else {
      toggleCantonsList(true)
    }
  }

  function selectCanton(el: any) {
    const e = {
      target: {
        value: el.value,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setShowCantons([])
    setShowAllCantons(false)
  }

  function removeCanton() {
    const e = {
      target: {
        value: '',
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
    setShowCantons([])
    setShowAllCantons(false)
  }

  function toggleCantonsList(close?: boolean) {
    const newState = close ? false : !showAllCantons
    const eventName = 'mousedown'
    if (!(props.formReadOnly || props.disabledInput)) {
      if (newState) {
        document.addEventListener(eventName, handleDocumentClick, false)
        setShowCantons(optionsToRender)
      } else {
        document.removeEventListener(eventName, handleDocumentClick, false)
        setShowCantons([])
      }
      setShowAllCantons(newState)
    }
  }

  return (
    <>
      {props.visible && (
        <div style={{ position: 'relative' }} className="formGroup" ref={cantonsRef}>
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="selectArea">
            <input
              readOnly={true}
              //   disabled={true}
              style={{ cursor: 'default' }}
              type="text"
              name={`fieldnameveryunique${new Date().getTime()}`}
              autoComplete="none"
              list="autocompleteOff"
              className="required-highlight transparent"
              onClick={(e) => toggleCantonsList()}
            />
            {props.value?.length > 0 &&
              !showAllCantons &&
              optionsToRender
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(
                  (el) =>
                    el.value === props.value && (
                      <div className="cantonsOptionInInput">
                        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                          <div className="colorImage" style={{ backgroundColor: `${el.value.toLowerCase()}` }} />
                          {/* <img src={`../../../../../kantons/${el.value}.svg`} width="12" height="14" /> */}
                          {el.name}
                        </div>
                        {!(props.formReadOnly || props.disabledInput) && (
                          <i onClick={(e) => removeCanton()} className="icon-clear" />
                        )}
                      </div>
                    )
                )}
            <div className="cantonsOptionArea">
              {showCantons
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((el) => (
                  <a className="cantonsOption" onClick={(e) => selectCanton(el)}>
                    <div className="colorImage" style={{ backgroundColor: `${el.value.toLowerCase()}` }} />

                    {/* <img src={`../../../../../kantons/${el.value}.svg`} width="12" height="14" /> */}
                    {el.name}
                  </a>
                ))}
            </div>
            <i className="icon-bottom" />
          </div>
        </div>
      )}
    </>
  )
}
export default ColorSelect
